import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './LoginPopup.css';

const LoginPopup = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Check for betaKey query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const betaKey = urlParams.get('betaKey');
    
    if (betaKey === 'zohranpreview') {
      // Grant instant access and store authentication
      localStorage.setItem('isAuthenticated', 'true');
      setShowLogin(false);
      return;
    }
    
    // Check if user has already logged in (stored in localStorage)
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (!isAuthenticated) {
      setShowLogin(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === 'nevergraduate') {
      localStorage.setItem('isAuthenticated', 'true');
      setShowLogin(false);
      setError('');
    } else {
      setError('Invalid beta code. Please try again.');
      // Shake animation trigger
      setPassword('');
    }
  };

  return (
    <AnimatePresence>
      {showLogin && (
        <motion.div
          className="login-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="login-popup-content"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
            transition={{ 
              type: "spring", 
              stiffness: 300, 
              damping: 20,
              delay: 0.2 
            }}
          >
            <motion.div
              className="lock-icon"
              animate={{ 
                rotate: [0, -5, 5, -5, 0],
                scale: [1, 1.05, 1]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                repeatDelay: 3
              }}
            >
              🔒
            </motion.div>
            
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              Website Under Construction
            </motion.h2>
            
            <motion.p
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.7 }}
            >
              Enter beta code to continue
            </motion.p>
            
            <motion.form
              className="login-form"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.9 }}
              onSubmit={handleSubmit}
            >
              <input
                type="password"
                placeholder="Enter beta code"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={error ? 'error' : ''}
                autoFocus
              />
              
              {error && (
                <motion.div
                  className="error-message"
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  {error}
                </motion.div>
              )}
              
              <button 
                type="submit"
                className="login-button"
              >
                Enter
              </button>
            </motion.form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoginPopup;

